import { forwardRef } from "react";

import { Circle, type CircleProps } from "@eisox/design-system";
import { BoilerRoomIcon } from "@eisox/icons";

const BoilerRoom = forwardRef<HTMLDivElement, CircleProps>(
  ({ size = 20, backgroundColor = "blue", color = "white", ...props }, ref) => (
    <Circle.Root {...props} ref={ref} size={size} backgroundColor={backgroundColor} color={color}>
      <BoilerRoomIcon />
    </Circle.Root>
  ),
);

BoilerRoom.displayName = "BoilerRoom";

export default BoilerRoom;
export { BoilerRoom };
